namespace $ {
	export class $aspirity_account_contact_select extends $mol_view {
		
		/**
		 * ```tree
		 * sub /
		 * 	<= Select
		 * 	<= Add
		 * ```
		 */
		sub() {
			return [
				this.Select(),
				this.Add()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * value?val \
		 * ```
		 */
		@ $mol_mem
		value(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * dict *
		 * ```
		 */
		dict() {
			return {
			}
		}
		
		/**
		 * ```tree
		 * Select $mol_select
		 * 	value?val <=> value?val
		 * 	dictionary <= dict
		 * ```
		 */
		@ $mol_mem
		Select() {
			const obj = new this.$.$mol_select()
			
			obj.value = (val?: any) => this.value(val)
			obj.dictionary = () => this.dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Add_icon $mol_icon_plus
		 * ```
		 */
		@ $mol_mem
		Add_icon() {
			const obj = new this.$.$mol_icon_plus()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Add $mol_link
		 * 	arg * contact \
		 * 	sub / <= Add_icon
		 * ```
		 */
		@ $mol_mem
		Add() {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				contact: ""
			})
			obj.sub = () => [
				this.Add_icon()
			] as readonly any[]
			
			return obj
		}
	}
	
}

